import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);

export function scrollToBottom(){
        const scrollBottom=document.querySelector('.scroll-bottom');
        const scrollBottomTarget=document.querySelector('.scroll-bottom-target');
        if(!scrollBottom || !scrollBottomTarget) {
            console.error('scrollBottom or scrollBottomTarget not found');
        }else{
            scrollBottom.addEventListener('click',function(e){
                e.preventDefault();
                gsap.to(window, {
                    duration: 0.1, // smoother scroll
                    scrollTo: {
                        y: scrollBottomTarget,
                        offsetY: 100 // adjust this value as needed
                    },
                });
            })
        }
        
    }